import ReactAudioPlayer from "react-audio-player";
import Et3Image from "../../../../../../../core/et3-Image";
import { withLiteObserverAndTheme } from "../../../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../../../core/et3-text";
import configuration from "../../../../../../../configuration/keys";
import ET3Div from "../../../../../../../core/et3-div";
import Et3Margin from "../../../../../../../core/et3-ui/ET3Margin";
import getCoreHistoryStore from "../../../../../../../stores/core/core-history-store";
import { parseEscapedNewlines } from "../../../../../../../helpers/et3-conversation-parse";

const MessageBody = withLiteObserverAndTheme<{
  message: string;
  messageType: string;
  isKhattabaMessage: boolean;
}>((props) => {
  const { message, messageType, isKhattabaMessage, theme } = props;
  const { unitX, unitY, colors } = theme;

  let finalizedMessage = `${message}`;
  if (messageType === "voice") {
    const validString = message.replace(/[\u201C\u201D]/g, '"');
    const messageObject = JSON.parse(validString);
    const voiceUrl = `${configuration.voiceAttachmentUrl}${messageObject.attachment}`;
    finalizedMessage = voiceUrl;
  } else if (messageType === "picture") {
    const validString = message.replace(/[\u201C\u201D]/g, '"');
    const messageObject = JSON.parse(validString);
    const imageUrl = `${configuration.imageAttachmentUrl}${messageObject.attachment}`;
    finalizedMessage = imageUrl;
  } else if (messageType === "sticker") {
    finalizedMessage = `ALKHATTABA_APP_STICKER_${message}`;
  }

  const textMessageColor = isKhattabaMessage
    ? colors.all.black
    : colors.all.white;
  switch (messageType) {
    case "text":
    case "sticker":
    case "automated":
      return (
        <Et3Text
          fontFamily={"LIGHT"}
          fontSize={16}
          isSpan={false}
          text={parseEscapedNewlines(finalizedMessage)}
          style={{
            maxWidth: 650 * unitX,
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            minHeight: 40 * unitY,
            textAlign: "start",
            wordBreak: "break-word",
            whiteSpace: "break-spaces"
          }}
          color={textMessageColor}
        />
      );
    case "picture":
      return (
        <ET3Div
          width={0}
          height={0}
          alignItems={"center"}
          fDirection={"column"}
          color={""}
          justifyContent={"center"}
          withShadow={false}
          isExtendable={true}
          isScrollable={false}
          onClick={() => {}}
          style={{
            width: "auto",
            maxWidth: 650 * unitX
          }}
        >
          <Et3Margin top={4} bottom={4} left={0} right={0} />
          <Et3Image
            type="ONLINE"
            alt={"Message"}
            imageName={finalizedMessage}
            size={200}
            onClick={() => {
              getCoreHistoryStore().openNewTab(finalizedMessage);
            }}
            style={{
              borderRadius: 5 * unitX
            }}
          />
          <Et3Margin top={2} bottom={4} left={0} right={0} />
        </ET3Div>
      );
    case "voice":
      return (
        <ET3Div
          width={0}
          height={100}
          alignItems={"center"}
          fDirection={"row"}
          color={""}
          justifyContent={"center"}
          withShadow={false}
          isExtendable={false}
          isScrollable={false}
          onClick={() => {}}
          style={{
            width: "auto",
            maxWidth: 650 * unitX,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <ReactAudioPlayer
            src={finalizedMessage}
            autoPlay={false}
            controls
            style={{ maxWidth: 650 * unitX }}
          />
        </ET3Div>
      );
    default:
      return null;
  }
});

export default MessageBody;
